import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import {
  callTenantSetStatus,
  callTenantPurge,
  type TenantSetStatusInput,
  type TenantSetStatusResponse,
  type TenantPurgeInput,
  type TenantPurgeResponse,
} from '../api/tenantLifecycle.js';

/**
 * S-71: `tenantSetStatus` Callable を呼ぶ mutation hook。
 * 成功時は `['tenants']` を invalidate して一覧を再取得。
 */
export function useTenantSetStatus(): UseMutationResult<
  TenantSetStatusResponse,
  Error,
  TenantSetStatusInput
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: TenantSetStatusInput) => callTenantSetStatus(input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['tenants'] });
    },
  });
}

/**
 * S-71: `tenantPurge` Callable を呼ぶ mutation hook。
 * 成功時は `['tenants']` を invalidate して一覧を再取得。
 */
export function useTenantPurge(): UseMutationResult<
  TenantPurgeResponse,
  Error,
  TenantPurgeInput
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: TenantPurgeInput) => callTenantPurge(input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['tenants'] });
    },
  });
}
